import { useMemo } from 'react'

import { DateTime } from 'luxon'

import { StatusBadge, Table, Text } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useSelector from '@hooks/useSelector'

import type { OrderItemModel } from '@models/types'

import { statusColors } from '@functions/status'

import type { EntitiesState } from '@redux/entities'

const buildColumns = (services: EntitiesState['services'], statuses: EntitiesState['statuses']) => [
  {
    title: 'Order Item',
    dataKey: 'title',
    render: (title: string, orderItem: OrderItemModel) => (
      <Text variant="ellipsis">
        {title} {orderItem.options_string}
      </Text>
    ),
  },
  {
    title: 'Qty',
    dataKey: 'quantity',
    cellProps: {
      textAlign: 'center',
      width: 40,
    },
  },
  {
    title: 'Order ID',
    dataKey: 'order_id',
    cellProps: {
      textAlign: 'right',
      width: 40,
    },
  },
  {
    title: 'Service',
    dataKey: 'service_id',
    cellProps: {
      width: 50,
    },
    render: (service_id: number) => services[service_id]?.title,
  },
  {
    title: 'Due Date',
    dataKey: 'dates',
    cellProps: {
      textAlign: 'center',
      width: 50,
    },
    render: (dates: object) => {
      const dueDate = digObject(dates, 'due.date')
      const dueDateFormatted = dueDate ? DateTime.fromFormat(dueDate, 'dd/MM/yyyy').toFormat('d LLL yyyy') : 'N/A'

      return (
        <StatusBadge
          text={dueDateFormatted}
          color="lightestGrey"
          textProps={{ color: 'bodyFontLightColor' }}
        />
      )
    },
  },
  {
    title: 'Status',
    dataKey: 'status_id',
    cellProps: {
      width: 40,
      textAlign: 'center',
    },
    render: (status_id: number) => {
      const status = statuses[status_id]

      return (
        status?.key && (
          <StatusBadge
            // @ts-expect-error TS7053
            color={statusColors[status.key]}
            ghost
            text={status.title}
          />
        )
      )
    },
  },
]

const OrderItemsTable = (props: { orderItems: OrderItemModel[] }) => {
  const { orderItems } = props

  const {
    _updates: {
      // @ts-expect-error TS2339
      services: servicesUpdatedAt,
      // @ts-expect-error TS2339
      statuses: statusesUpdatedAt,
    },
    services,
    statuses,
  } = useSelector(reduxState => reduxState.entities)

  const memoColumns = useMemo(
    () => buildColumns(services, statuses),
    [orderItems.length, servicesUpdatedAt, statusesUpdatedAt],
  )

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      // @ts-expect-error TS2322
      data={orderItems}
      stickyHeader
    />
  )
}

export default OrderItemsTable
